const deleteBlock = (b) => {
    b.replaceWith('')
    //setTimeout(()=>{b.replaceWith('')}, 2000);
}
export const offersFlow = (offerProp, offersFlowFromLink, editor, bm) => {
    const comps = editor.DomComponents;
    const defaultType = comps.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;
    const linkType = comps.getType('link');
    // editor.DomComponents.addType('img-link', {
    //     model: defaultModel.extend({
    //         defaults: Object.assign({}, defaultModel.prototype.defaults, {
    //             removable: 1,
    //             resizable: {
    //                 updateTarget: function (element, rect) {
    //                     const w = rect.w + 'px';
    //                     const h = rect.h + 'px';

    //                     let img = element.querySelector('img');

    //                     img.setAttribute('width', w);
    //                     img.setAttribute('height', h);
    //                 }
    //             },
    //             traits: [
    //                 {
    //                     type: 'text',
    //                     label: 'Lien',
    //                     name: 'href',
    //                     changeProp: 1
    //                 },
    //                 {
    //                     type: 'text',
    //                     label: 'titre',
    //                     name: 'title',
    //                     changeProp: 1
    //                 }
    //             ]
    //         }),
    //         initialize: function initialize() {
    //             if (this.get('style')) {
    //                 this.set('style', this.get('style'))
    //             }

    //             defaultModel.prototype.initialize.apply(this, arguments);

    //             this.listenTo(this, 'change:src', this.updateSrc);
    //             this.listenTo(this, 'change:href', this.updateHref);
    //             this.listenTo(this, 'change:title', this.updateTitle);
    //         },
    //         updateSrc: function (component, value) {
    //             component.view.$el.find('img').attr('src', value);
    //         },
    //         updateHref: function (component, value) {
    //             component.view.$el.find('a').attr('href', value);
    //         },
    //         updateTitle: function (component, value) {
    //             component.view.$el.find('a').attr('title', value);
    //         }
    //     },
    //         {
    //             isComponent: function (el) {
    //                 if (el.classList && el.classList.contains('img-link')) {
    //                     return { type: 'img-link', el: el, style: el.style };
    //                 }
    //             }

    //         }),
    //     view: defaultType.view.extend({
    //         tagName: 'span',

    //         events: {
    //             dblclick: 'openModal',
    //             click: 'openSettings'
    //         },

    //         openSettings: function (e) {
    //             e.preventDefault();

    //             editor.select(this.model);
    //             editor.Panels.getButton('views', 'open-tm').set('active', 1);
    //         },

    //         openModal: function () {
    //             if (editor) {
    //                 editor.runCommand('open-assets', {
    //                     target: this.model,
    //                     onSelect: function onSelect() {
    //                         editor.Modal.close();
    //                         editor.AssetManager.setTarget(null);
    //                     }
    //                 });
    //             }

    //             this.$el.click();
    //         },

    //         getNodes: function () {
    //             if (!this.imgLink) {
    //                 let img = document.createElement('img');
    //                 let a = document.createElement('a');

    //                 a.classList.add('img-link', 'link');
    //                 a.style.display = 'inline-block';
    //                 img.src = 'http://placehold.it/267x141';
    //                 img.style.objectFit = 'cover';

    //                 a.appendChild(img);

    //                 this.imgLink = a;
    //             }

    //             return this.imgLink;
    //         },

    //         render: function () {
    //             defaultView.prototype.render.apply(this, arguments);

    //             this.el.appendChild(this.getNodes());

    //             return this;
    //         }
    //     })
    // });

    // //const bm = editor.BlockManager;

    // bm.add('img-link', {
    //     label: 'Lien Image',
    //     category: 'Blocs',
    //     content: {
    //         type: 'img-link',
    //         attributes: {
    //             'class': 'img-link'
    //         }
    //     },
    //     attributes: {
    //         class: 'fa fa-picture-o'
    //     }
    // });

    // editor.DomComponents.addType('imagelink', {
    //     model: {
    //         defaults: {
    //             tagName: 'div',
    //             resizable: { keepAutoHeight: true },
    //             droppable: false,
    //             traits: [
    //                 {
    //                     type: 'href', label: 'Source', name: 'href'
    //                 },
    //                 {
    //                     type: 'select',
    //                     label: 'Target',
    //                     name: 'target',
    //                     options: [
    //                         { value: '', name: 'This window' },
    //                         { value: '_blank', name: 'New window' }
    //                     ]
    //                 }
    //             ],
    //             components: [
    //                 {
    //                     resizable: false,
    //                     draggable: false,
    //                     droppable: false,
    //                     selectable: false,
    //                     hoverable: false,
    //                     type: 'link',
    //                     components: [{
    //                         type: 'image',
    //                         attributes: {
    //                             src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTMuNWwyLjUgMyAzLjUtNC41IDQuNSA2SDVtMTYgMVY1YTIgMiAwIDAgMC0yLTJINWMtMS4xIDAtMiAuOS0yIDJ2MTRjMCAxLjEuOSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMnoiPjwvcGF0aD4KICAgICAgPC9zdmc+',
    //                             style: 'width:100%;'
    //                         },
    //                         resizable: false,
    //                         draggable: false,
    //                         droppable: false,
    //                         hoverable: false,
    //                         selectable: false,
    //                     }]
    //                 }
    //             ]
    //         },
    //         init() {
    //             this.on('change:attributes:href', this.handleHrefChange);
    //             this.on('change:attributes:target', this.handleTargetChange);
    //         },
    //         handleHrefChange: function (component, value) {
    //             delete component.attributes.attributes;
    //             component.attributes.components.models[0].attributes.attributes.href = value;
    //             return false;
    //         },
    //         handleTargetChange: function (component, value) {
    //             delete component.attributes.attributes;
    //             component.attributes.components.models[0].attributes.attributes.target = value;
    //             return false;
    //         },
    //     },

    //     isComponent(el) {
    //         if (

    //             el.classList &&
    //             el.classList.contains("imgextended")
    //         ) {
    //             return { type: "imageextended" };
    //         }
    //     },

    // });



    if (offerProp || offersFlowFromLink == 'offers') {
        const blocks = bm.getAll();

        blocks.forEach(b => {

        })
        const filtered = blocks.filter(block => block.get('label') != 'Text')
        filtered.forEach(b => {

            bm.remove(b)

        })
        editor.on("block:drag:stop", (block) => {
            if (block == null) {
                return
            }
            var x = editor.getHtml();
            let el = document.createElement('div');
            el.id = "ttttt123"
            el.innerHTML = x;
            let res = el.querySelector('f');




            if (block.toHTML() == '<img style="width:0;height:0;" >')
                return

            // check for text
            if (block.toHTML().includes('Insert your text here')) {

                try {
                    let arr = el.querySelectorAll('h5')

                    el.querySelector("#" + block.getAttributes().id).innerHTML = '';

                    let t1 = el.innerText;
                    let t2 = '';
                    arr.forEach(i => {
                        t2 += i.innerText;
                    })

                    t1 = t1.replace(/ +/g, '');
                    t2 = t2.replace(/ +/g, '');





                    if (t1 != t2) {
                        deleteBlock(block)
                        alert(" only one TEXT element is allowed")
                    }
                } catch (e) {

                }
                // var tag_names = [
                //     'div',
                //     'h1',
                //     'h2',
                //     'h3',
                //     'h4',
                //     'h5',
                //     'h6'
                // ]
                // let flag = false;
                // tag_names.forEach(n => {
                //     let t = el.querySelectorAll(n)
                //     if (n == 'div') {
                //         t.forEach(i => {
                //             if (i.id != 'ttttt123' && i.id != block.getAttributes().id && i.innerText != '') {
                //                 //block.replaceWith('<img style="width:0;height:0;" >')
                //                 flag = true
                //             }
                //         })

                //     }
                //     else if (t.length > 0) {
                //         flag = true

                //     }
                // // })
                // if (flag) {
                //   //  deleteBlock(block)
                //     //alert(" only one TEXT element is allowed")
                // }

            }
            else if (block.toHTML().includes('Link')) {
                let t = el.querySelectorAll('a')
                let flag = false
                t.forEach(i => {
                    if (i.id != 'ttttt123' && i.id != block.getAttributes().id) {
                        flag = true
                    }
                })
                if (flag) {
                    deleteBlock(block)
                    // block.replaceWith('<img style="width:0;height:0;" >')
                    alert(" only one LINK element is allowed")

                }

            }
            else if (block.toHTML().includes('img')) {
                try {
                    let t = el.querySelectorAll('img')
                    let flag = false

                    t.forEach(i => {
                        if (i.id != 'ttttt123' && i.id != block.getAttributes().id) {
                            flag = true
                        }
                    })
                    if (flag) {
                        deleteBlock(block)
                        // block.replaceWith('<img style="width:0;height:0;" >')
                        alert(" only one Image element is allowed")

                    }
                } catch (e) {

                }

            }

            //   if(el.querySelector('div'))
            //  
        })

        const imageType = editor.DomComponents.getType("image");
        editor.DomComponents.addType("image-extended", {
            model: imageType.model.extend(
                {
                    defaults: Object.assign({}, imageType.model.prototype.defaults, {
                        name: "Image-link",

                        traits: [
                            {
                                label: 'alt',
                                name: 'alt',
                                placeholder: ''
                            },
                            {
                                label: 'Link',
                                name: 'href',
                                placeholder: 'http://meusite.com.br'
                            },

                        ],
                    }),
                },
                {
                    isComponent(el) {
                        if (
                            el.tagName === "IMG" &&
                            el.classList &&
                            el.classList.contains("img-extended")
                        ) {
                            return { type: "image-extended" };
                        }
                    },
                }
            ),
            view: imageType.view,
        });

        editor.on("component:add", (block) => {

            if (block.toHTML() == '<img style="width:0;height:0;" >')
                return

            if (block.toHTML() == '<div id="test"></div>') {

                //  currentAddedBlock = block;
                var x = editor.getHtml();
                let el = document.createElement('div');
                el.id = "ttttt123"
                el.innerHTML = x;
                let res = el.querySelectorAll('img');

                if (res && res.length > 0) {
                    block.replaceWith('')
                    alert("only one Image is allowed")
                } else {
                    block.replaceWith(` 
                                    <div style='display:flex' class='imageLink'>
                                     <img style="height:500px; width:100%;" class='img-extended' src= 'https://s3.amazonaws.com/public.dashboard.kw.com/company1.kapitalwise.net/assets/placeholder.jpg'  >
                                     </img>

                                      <h5 style="
                                                z-index: 100000;
                                                position: absolute;
                                                margin : 20px;
                                                margin-Top:50px;
                                                color: black;
                                                font-size:38px;
                                                 font-family: Arial;
                                                 width:90%;
                                            ">INSERT TITLE HERE</h5>


                                      <h5 style="
                                                z-index: 100000;
                                                position: absolute;
                                                margin : 20px;
                                                margin-Top:120px;
                                                color: black;
                                                font-size:28px;
                                                font-family: Arial;
                                                width:90%;
                                            ">INSERT SUBTITLE HERE</h5>

                                      <h5 style="
                                                z-index: 100000;
                                                position: absolute;
                                                margin : 20px;
                                                margin-Top:170px;
                                                color: black;
                                                font-size:20px;
                                                width:90%;
                                                height:200px;
                                                
                                            ">INSERT DESCRIPTION HERE</h5>

                                     </div>

                                     `)

                }
            }


        });
        bm.add('Card').set({
            label: 'Img',
            category: 'Basic',
            attributes: { class: 'fa fa-image' },
            content: '<div id="test"></div>'

        });

    }


}

///


// editor.DomComponents.addType('InputGroup', {
//     model: {
//         defaults: {
//             // The tag name that will be used in the final code
//             tagName: 'InputGroup',
//             components: model => {
//                 return `<a><img src='${model.attributes.src}'></img></a>`;
//             },
//             attributes: { customProp: 'val1', src: 'https://via.placeholder.com/150' },
//             // You would use traits to customize custom properties
//             traits: [
//                 {
//                     type: 'select',
//                     name: 'customProp',
//                     options: [
//                         { value: 'val1', name: 'Value 1' },
//                         { value: 'val2', name: 'Value 2' },
//                     ]
//                 },
//                 {
//                     type: 'text',
//                     label: 'Lien',
//                     name: 'href',
//                     changeProp: 1
//                 }
//                 ,
//                 {
//                     type: 'text',
//                     label: 'Lien',
//                     name: 'href',
//                     changeProp: 1
//                 }
//             ]
//         }
//     },
//     init() {
//         this.on('change:provider', this.handlePropChange);
//         // Listen to any attribute change
//         this.on('change:attributes', this.handleAttrChange);
//         // Listen to title attribute change
//         this.on('change:attributes:title', this.handleTitleChange);


//     },

//     handlePropChange() {
//         const { someprop } = this.props();
//         
//     },

//     handleAttrChange() {
//         
//     },

//     handleTitleChange() {
//         
//     },

//     //       view: {
//     //         // eg. You can customize the tag in the canvas
//     //         // By default, the view will use the same tag of the model
//     //         tagName: 'div',
//     //         onRender() {
//     //           // What the user see in the canvas is totally up to you
//     //           // it can be a simple image as a placeholder or
//     //           // you can make it as much close to the original markup

//     //           const attrs = this.model.getAttributes();
//     //           
//     //           this.el.innerHTML = `<div>
//     // 	My custom HTML for this component<br>
//     // 	My custom prop: ${attrs['customProp']}  ${attrs['Lien']}
//     //   <span>ff</span>
//     // </div>`;
//     //         }
//     //       },

// });

// bm.add('InputGroup', {
//     label: 'Lien Image',
//     category: 'Blocs',
//     content: {
//         type: 'InputGroup',
//         attributes: {
//             'class': 'InputGroup'
//         }
//     },
//     attributes: {
//         class: 'fa fa-picture-o'
//     }
// });